export default {
    onsiteStatus: 'สถานะการไปนอกสถานที่',
    noDataMessage: 'ไม่มีพนักงานเข้างานนอกสถานที่ในวันนี้',
    employeeId: 'รหัสพนักงาน',
    name: 'ชื่อ - นามสกุล',
    bureauShort: 'สำนักงาน / หน่วยงาน (ชื่อย่อ)',
    positionShort: 'ตำแหน่ง (ชื่อย่อ)',
    date: 'วันที่',
    checkInTime: 'เวลาเข้างาน',
    status: 'สถานะ'
}
